export * from './src/ecom-custom-trigger-v1-custom-trigger-discounts-custom-trigger.schemas.js';
